import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TypeFilter } from 'src/app/models/enums/TypeFilter.enum';
import { FieldConfig } from 'src/app/models/types/Filters.type';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'app-input',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent implements OnInit {

  @Input('config') config!: FieldConfig;
  @Input('customFormControl') customFormControl?: FormControl;

  public formControl!: FormControl;

  constructor(
    private readonly translateService: TranslateService,
    private readonly filtersService: FiltersService
  ) { }

  ngOnInit(): void {
    if (this.customFormControl) {
      this.formControl = this.customFormControl;
      return;
    }
    this.formControl = this.filtersService.getFormControl(this.config.field);
  }

  public get TypeFilter() {
    return TypeFilter;
  }

  public get type(): string {
    if (this.isTCurrencyType) {
      return "number";
    }
    return "text";
  }

  public get isTextType(): boolean {
    return this.config.type === TypeFilter.TEXT;
  }

  public get isTCurrencyType(): boolean {
    return this.config.type === TypeFilter.CURRENCY;
  }

  public get errors(): string[] {
    return this.formControl.errors ? Object.keys(this.formControl.errors) : [];
  }

  getErrorMessage(key: string): string {
    let value: any;
    if (this.formControl.errors) {
      value = this.formControl.errors[key][key];
    }
    return this.translateService.instant(`filter.${this.config.field}.errors.${key}`, { n: value });
  }

}
